<template>
  <w-icon-wrapper
    :height='24'
    :width='24'
    icon-name='work-payment-reminder-icon'
    view-box='0 0 24 24'
  >
    <g
      id="_126_Senden_einer_Zahlungserinnerung"
      data-name="_126_Senden_einer_Zahlungserinnerung"
    >
      <path
        id='Pfad 1'
        d='M22,18h-2v-8c0-3.73-2.55-6.85-6-7.74v-.26c0-1.1-.9-2-2-2s-2,.9-2,2v.26c-3.45.89-6,4.01-6,7.74v8h-2c-.55,0-1,.45-1,1s.45,1,1,1h2s3.55,0,3.55,0c.25,2.24,2.14,4,4.45,4s4.2-1.76,4.45-4h3.55s2,0,2,0c.55,0,1-.45,1-1s-.45-1-1-1ZM6,10c0-3.31,2.69-6,6-6s6,2.69,6,6v8H6v-8ZM12,22c-1.21,0-2.22-.86-2.45-2h4.9c-.23,1.14-1.24,2-2.45,2Z'
        data-name='Pfad 1'
        fill='currentColor'
      />
      <path
        id='Pfad 2'
        d='M13.49,12.95h-2.08c.02.61.18,1.06.49,1.37s.78.46,1.42.46c.43,0,.83-.06,1.18-.19l.22,1.5c-.51.12-1.04.18-1.59.18-1.09,0-1.95-.29-2.58-.88s-.97-1.4-1-2.44h-1.05v-.94h1.05v-.77h-1.05v-.94h1.06c.07-1.04.43-1.85,1.09-2.43s1.52-.87,2.61-.87c.43,0,.92.06,1.46.19l-.22,1.51c-.39-.13-.77-.2-1.15-.2-1.17,0-1.81.6-1.92,1.79h2.07v.94h-2.08v.77h2.08v.94Z'
        data-name='Pfad 2'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconPaymentReminder' };
</script>
